export class ContattoVO {
  idSoggetto: string;
  idRecapito: string;
  nome: string;
  indirizzo: string;
  immagine: string;
}
